import React, { useEffect, useState, useCallback } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import "../css/NewNavbar.css";
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import { FaAngleDown } from "react-icons/fa6";
import { VscAccount } from "react-icons/vsc";
import { RiTwitterXFill } from "react-icons/ri";
import { RiInstagramFill } from "react-icons/ri";
import { RiFacebookCircleFill } from "react-icons/ri";
import { RiWhatsappFill } from "react-icons/ri";
import { RiLinkedinBoxFill } from "react-icons/ri";
import * as imagesdata from '../imagesdata'

const NewNavbar = ({ lenis, routes, isLenisRunning, showAppNavbar, logout, user }) => {
    const [decodedUser, setDecodedUser] = useState({});
    const location = useLocation();
    const currentPath = location.pathname;
    const modelPathPattern = /^\/urun\/[^/]+$/;
    const matchedRoutes = matchRoutes(routes, location);
    const isModelPath = modelPathPattern.test(currentPath) || !matchedRoutes || matchedRoutes[0].route.path === "*";;
    const [scrolled, setScrolled] = useState(isModelPath);
    const [menuVisible, setMenuVisible] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 1200);
    const showNavbar = location.pathname !== "/giris-yap" && location.pathname !== "/kayit-ol" && location.pathname !== "/sifremi-unuttum" &&
        location.pathname !== "/sifremi-sifirla"
    const [navDropdownActive, setNavDropdownActive] = useState(false)
    const [accessToken, setAccessToken] = useState(null)
    useEffect(() => {
        const handleScroll = () => {
            if (isModelPath === true) {
                setScrolled(true);
            } else if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        const handleResize = () => {
            setIsMobileView(window.innerWidth < 1200);
            if (window.innerWidth > 1200) {
                setMenuVisible(false);
                setActiveDropdown(null);
            }
            if (window.innerWidth < 1200) {
                setNavDropdownActive(false)
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, [isModelPath]);

    useEffect(() => {
        const token = Cookies.get('aToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setDecodedUser(decoded);
            } catch (error) {
                console.error("Token decoding failed:", error);
            }
        }
    }, [setDecodedUser])

    const handleLogout = () => {
        logout();
    }

    const toggleMenu = () => {
        setMenuVisible(prevState => !prevState);
        setActiveDropdown(null)
    };

    const toggleDropdown = useCallback((index) => {
        setActiveDropdown(prevState => (prevState === index ? null : index));
    }, []);

    const handleMouseEnter = useCallback((index) => {
        if (isMobileView == false) {
            setActiveDropdown(index);
        }
    }, [isMobileView]);

    const handleMouseLeave = useCallback(() => {
        if (isMobileView == false) {
            setActiveDropdown(null);
        }
    }, [isMobileView]);

    useEffect(() => {
        if (menuVisible) {
            lenis.stop();
            document.body.style.overflow = 'hidden';
        } else if (!menuVisible && isLenisRunning) {
            lenis.start();
            document.body.style.overflow = 'auto';
        }
        return () => {
            lenis.start();
        };
    }, [menuVisible, lenis]);

    useEffect(() => {

    }, [])

    const preventScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
    };

    const preventMiddleClickScroll = (e) => {
        if (e.button === 1) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };

    if (!showNavbar) {
        return <div></div>;
    } else {
        return (
            <div className={`navbar-header ${scrolled || menuVisible || showAppNavbar ? 'scrolled' : ''}`} >
                <nav className="nav nav-container">
                    <div className="nav__data">
                        <div className='nav__component__flex' >
                            <div className="nav__toggle" id="nav-toggle" onClick={toggleMenu}>
                                <i className={`nav__toggle-menu`}>
                                    <label className={`hamburger-icon ${menuVisible ? 'hamburger-icon-checked' : ''}`}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </label>
                                </i>
                            </div>
                        </div>
                        <li className='izlogo' style={{ listStyle: "none", margin: "0 10px" }}>
                            <a href='/'><img className='nav__logo__image' style={{ maxHeight: "150px", maxWidth: "210px", marginLeft: isMobileView ? "" : "60px", marginTop: "10px", zIndex: "100000" }} src={imagesdata.Logo} alt="Logo" /></a>
                        </li>
                        <div style={{ display: isMobileView == true ? "block" : "none" }}>
                            {user === null ? (<div class="skeleton-square skeleton-circle" style={{ marginRight: "16px" }} />) :
                                user === false ?
                                    (
                                        <li className='nav__account__icon' style={{ listStyle: "none", marginRight: "20px", marginTop: "5px" }}>
                                            <a href="/giris-yap"><VscAccount color='#fffdf1' size={25} /></a>
                                        </li>
                                    ) :
                                    (<div style={{ opacity: "0" }}><VscAccount color='#fffdf1' size={25} /></div>)}
                        </div>
                    </div>

                    <div {...(isMobileView && { 'data-lenis-prevent': true })} className={`nav__menu ${menuVisible ? 'show-menu' : ''}`} id="nav-menu">
                        <ul className="nav__list">
                            <li className="nav__link__li">
                                <a href="/" className="nav__link">Ana Sayfa</a>
                            </li>

                            <li className="nav__link__li">
                                <a href="/trafik-akisi" className="nav__link">Trafik Akışı</a>
                            </li>

                            <li
                                className="nav__dropdown__item"
                                onMouseEnter={() => handleMouseEnter(1)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <div className={`nav__link nav__dropdown__button ${activeDropdown === 1 ? 'nav__show__button' : ''}`} onClick={() => toggleDropdown(1)}>
                                    Hakkımızda <i className="nav__dropdown__arrow">
                                        <FaAngleDown size={20}
                                            style={{
                                                transform: activeDropdown === 1 ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease', marginTop: "11px"
                                            }}
                                        />
                                    </i>
                                </div>

                                <div className={`nav__dropdown__container ${activeDropdown === 1 ? 'nav__show-dropdown' : ''}`}>
                                    <div className="nav__dropdown__content">
                                        <div className="nav__dropdown__group">
                                            <div className="nav__dropdown__icon">
                                                <img style={{ width: "45px", marginTop: "-4px" }}
                                                    src={imagesdata.NavIconBizKimiz} />
                                            </div>

                                            <span className="nav__dropdown__title"><a style={{ color: "#0c172c" }} href="/biz-kimiz">Biz Kimiz</a></span>

                                            <ul className="nav__dropdown__list">
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                            </ul>

                                        </div>



                                        <div className="nav__dropdown__group">
                                            <div className="nav__dropdown__icon">
                                                <img style={{ width: "40px", marginTop: "" }}
                                                    src={imagesdata.NavIconSüreclerimiz} />
                                            </div>

                                            <span className="nav__dropdown__title"><a style={{ color: "#0c172c" }} href="/surecler">Üretim Süreçlerimiz</a></span>

                                            <ul className="nav__dropdown__list">
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                            </ul>
                                        </div>

                                        <div className="nav__dropdown__group">
                                            <div className="nav__dropdown__icon">
                                                <img style={{ width: "45px", marginTop: "-4px" }}
                                                    src={imagesdata.NavIconReferanslar} />
                                            </div>

                                            <span className="nav__dropdown__title"><a style={{ color: "#0c172c" }} href="/referanslar">Referanslarımız</a></span>

                                            <ul className="nav__dropdown__list">
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                                <li><a href="" className="nav__dropdown__link"></a></li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </li>

                            <li className="nav__link__li">
                                <a href="/iletisim" className="nav__link">İletişim</a>
                            </li>
                            <div style={{ display: isMobileView == true ? "block" : "none" }}>
                                {user == null ? (<div class="skeleton-line h25 w50"></div>) : user == false ? null : (
                                    <li className="nav__link__li" onClick={() => handleLogout()}>
                                        <a style={{ position: "relative", cursor: "pointer" }} className="nav__link nav__link__not__between">
                                            <svg style={{ marginRight: "10px", height: "25px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#3da58a" d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z" /></svg>
                                            Çıkış Yap
                                        </a>
                                    </li>
                                )}
                            </div>
                            <div className='nav__link__social'>
                                <img style={{ maxHeight: "120px", maxWidth: "168px", width: "100%", height: "100%", marginTop: "50px" }} src={imagesdata.TersLogo} alt="Logo" />
                            </div>

                            <div className='nav__link__social'>Sosyal Medya Hesaplarımız</div>
                            <ul className='nav__link__social'>
                                <li><a href='https://www.facebook.com/people/Burak-Duyar/pfbid02MsUA1wMsNPcFMjG1EmKC5LDGa7eeY7UjNEvdhvSRvP9vjasdNiKiCwhhe74HGunfl/' target="_blank" rel="noopener noreferrer"><RiFacebookCircleFill size={30} /></a></li>
                                <li><a href='https://wa.me/+905522483700' target="_blank" rel="noopener noreferrer"><RiWhatsappFill size={30} /></a></li>
                                <li><a href='https://www.instagram.com/burak_duyar37/' target="_blank" rel="noopener noreferrer"><RiInstagramFill size={30} /></a></li>
                                <li><a href='https://www.linkedin.com/in/burak-duyar-74a053282/' target="_blank" rel="noopener noreferrer"><RiLinkedinBoxFill size={30} /></a></li>
                                <li><a href='https://x.com/burak37duyar' target="_blank" rel="noopener noreferrer"><RiTwitterXFill size={25} /></a></li>
                            </ul>
                            {user === null ? (
                                <li className="nav__link_account">
                                    <a className="nav__link">
                                        <div class="skeleton-square skeleton-circle" style={{ marginRight: "6px" }} />
                                    </a>
                                </li>
                            ) : (
                                <li className="nav__link_account">
                                    <a className="nav__link"><VscAccount className='vscaccount' style={{ marginBottom: "2px", marginRight: "10px", cursor: "pointer" }} size={25} onClick={() => setNavDropdownActive(!navDropdownActive)} /></a>
                                </li>)}

                            <div className={`nav__link_account_dropdown-container ${navDropdownActive == true ? "active" : ""}`}>

                                <div style={{ backgroundImage: `url(${imagesdata.NavAuthShadow})` }} class="nav__link_account_shadow cut"></div>

                                <div style={{ display: user === null ? "none" : "block" }}>
                                    <div class="nav__link_account_container cut">
                                        <div class="nav__link_account_drop cut2"></div>
                                    </div>
                                </div>
                                <div class="nav__link_account_list">
                                    {user ? (
                                        <ul>
                                            <li className='nav__link_account_list_title' style={{ cursor: "auto" }}>
                                                <p>{user.email}</p>
                                            </li>
                                            <li className='nav__link_account_list_logout' onClick={() => handleLogout()}>
                                                <a>Çıkış Yap</a>
                                            </li>
                                        </ul>
                                    ) : (
                                        <ul>
                                            <li>
                                                <a href='/giris-yap'>Giriş Yap</a>
                                            </li>
                                            <li>
                                                <a href='/kayit-ol'>Üye Ol</a>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </ul>
                    </div>

                </nav>
            </div>
        );
    };
}

export default NewNavbar;